import React from "react";
import { Button } from "./ui/button";
import { Code2, Copy } from "lucide-react";
import { toast } from "sonner";

const snippet = () =>
  `<div id="softspine-shop"></div>\n<script src="${window.location.origin}/api/public/shop.js" async></script>`;

export const EmbedSnippet = () => {
  const copy = async () => {
    try { await navigator.clipboard.writeText(snippet()); toast.success("Snippet copied"); }
    catch { toast.error("Couldn't copy — select the text and copy it manually"); }
  };
  return (
    <div className="border border-border rounded-sm p-6 bg-card" data-testid="embed-snippet-card">
      <div className="flex items-start gap-3">
        <div className="h-9 w-9 rounded-sm flex items-center justify-center shrink-0 bg-accent/15 text-accent">
          <Code2 className="h-4 w-4" strokeWidth={1.5} />
        </div>
        <div className="flex-1 min-w-0">
          <div className="font-medium">Embed your shop on another website</div>
          <p className="text-xs text-muted-foreground mt-1 italic leading-relaxed">
            Paste this into any page (WordPress, Squarespace, Wix custom HTML block…). It shows every published book with
            search and category filter; "Buy now" asks for an email and goes straight to Stripe checkout.
          </p>
          <pre className="mt-4 text-xs bg-muted p-3 rounded-sm overflow-x-auto whitespace-pre" data-testid="embed-snippet-code">{snippet()}</pre>
          <Button onClick={copy} className="mt-3" size="sm" data-testid="embed-snippet-copy"><Copy className="h-3.5 w-3.5 mr-2" />Copy snippet</Button>
        </div>
      </div>
    </div>
  );
};
